import { Show as ShowBuilding } from "components/Buildings";
import { EditModal as EditDocument, Show as ShowDocument } from "components/Documents";
import { FormShow } from "v2/components/Forms";
import { Edit as EditLease } from "components/Leases";
import { Home, Missing } from "components/Pages";
import { Show as ShowCondition } from "components/Conditions";

import { List as ListPortfolios, Show as ShowPortfolio } from "components/Portfolios";

import { List as ListReports } from "components/Reports";
import { List as ListTodos } from "./components/Todos";

import { Edit as EditProject, Show as ShowProject } from "components/Projects";
import { List as ListProjects } from "v2/components/Projects";
import { List as ListProperties, Show as ShowProperty } from "components/Properties";
import { EditProperty } from "v2/components/Properties";
import { SignOut } from "components/Session";
import { LoadingState } from "components/Shared";
import { Masthead } from "v2/components/shared/Masthead";
import { List as ListTasks, Show as ShowTask } from "components/Tasks";
import { List as ListTemplates, Show as ShowTemplate } from "components/Templates";
import { Show as ShowTenancies, Edit as EditTenancy } from "components/Tenancies";
import { Edit as EditTenant } from "components/Tenants";
import { default as React, Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
// @ts-ignore
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { ProtectedRoute, UnprotectedRoute } from "routes";
import "scss/react-notifications.css";
import { Reset as PasswordReset, SignIn, SignUp } from "v2/components";
import { Create as CreateProject, Pending as PendingProjects } from "v2/components/Projects";
import SettingsPage from "v2/components/Settings";
import { SlaMonitor, SlaMonitorProperty, SlaConfiguration } from "v2/components/SlaMonitor";
import { ExecutiveDashboard } from "v2/components/ExecutiveDashboard";
import {
	AmendmentEdit,
	AmendmentShow,
	LeaseAgreementEdit,
	List as ListLeaseAgreements,
	Show as ShowLeaseAgreement
} from "v2/components/LeaseAgreements";
import { FormFill, SignerConfig, SignerView } from "v2/components/Conditions";

const fallback = (
	<React.Fragment>
		<Helmet>
			<body className="application-layout" />
		</Helmet>
		<Masthead />
		<LoadingState />
	</React.Fragment>
);

const App = () => (
	<Fragment>
		<NotificationContainer />
		<Router>
			<Suspense fallback={fallback}>
				<Switch>
					<UnprotectedRoute exact path="/password/reset" component={PasswordReset} />
					<UnprotectedRoute exact path="/signup/:token" component={SignUp} />
					<UnprotectedRoute exact path="/signup" component={SignUp} />
					<UnprotectedRoute exact path="/signin" component={SignIn} />
					<ProtectedRoute exact path="/signout" component={SignOut} />
					<ProtectedRoute path="/conditions/:id/fill" component={FormFill} />
					<ProtectedRoute path="/conditions/:id/signers" component={SignerConfig} />
					<ProtectedRoute path="/conditions/:id" component={ShowCondition} />
					<ProtectedRoute path="/signers/:id" component={SignerView} />
					<ProtectedRoute path="/tasks/:id" component={ShowTask} />
					<ProtectedRoute path="/tasks" component={ListTasks} />
					<ProtectedRoute path="/leases/:id/edit" component={EditLease} />
					{/* The YARDI side of a lease — LeaseAgreement, read only. A different
					    record from /leases above, which is TCP's own editable Lease.
					    Registered on its own path rather than as a /leases tab because the
					    tree spans several projects and belongs to none of them. */}
					{/* ABOVE the :id route, or the amendment path is swallowed by it. */}
					{/* THE AMENDMENT IS A VIEW WITH TWO TABS (Sim, 26 Aug) — Details, which
					    states the record and carries an Edit button, and Assets, read-only.
					    The form is its own page again, exactly as the lease's is, so BOTH
					    routes exist and the `/edit` one MUST be registered first: neither
					    route is `exact`, so the show path is a prefix of the edit path and
					    would otherwise swallow it. */}
					<ProtectedRoute
						path="/lease-agreements/:id/amendments/:amendmentId/edit"
						component={AmendmentEdit}
					/>
					<ProtectedRoute
						path="/lease-agreements/:id/amendments/:amendmentId"
						component={AmendmentShow}
					/>
					<ProtectedRoute path="/lease-agreements/:id/edit" component={LeaseAgreementEdit} />
					<ProtectedRoute path="/lease-agreements/:id" component={ShowLeaseAgreement} />
					<ProtectedRoute path="/lease-agreements" component={ListLeaseAgreements} />
					<ProtectedRoute path="/tenants/:id/edit" component={EditTenant} />
					<ProtectedRoute path="/properties/:property_id/buildings/:id" component={ShowBuilding} />
					<ProtectedRoute path="/properties/:id/edit" component={EditProperty} />
					<ProtectedRoute path="/properties/:id" component={ShowProperty} />
					<ProtectedRoute path="/properties" component={ListProperties} />

					<ProtectedRoute path="/portfolios/:id" component={ShowPortfolio} />
					<ProtectedRoute path="/portfolios" component={ListPortfolios} />

					{/* <ProtectedRoute path="/reports/:id" component={ShowReport} /> */}
					<ProtectedRoute path="/reports" component={ListReports} />
					<ProtectedRoute path="/todos" component={ListTodos} />

					{/* Registered ABOVE /projects/:id so they are not swallowed by the :id param match */}
					<ProtectedRoute path="/projects/pending" component={PendingProjects} />
					<ProtectedRoute path="/projects/:id/schedule" component={CreateProject} />
					<ProtectedRoute path="/projects/new" component={CreateProject} />
					<ProtectedRoute path="/projects/:id/edit" component={EditProject} />
					<ProtectedRoute path="/projects/:id" component={ShowProject} />
					<ProtectedRoute path="/projects" component={ListProjects} />
					<ProtectedRoute path="/documents/:id/edit" component={EditDocument} />
					<ProtectedRoute path="/documents/:id/:revision_id" component={ShowDocument} />
					<ProtectedRoute path="/documents/:id" component={ShowDocument} />
					<ProtectedRoute path="/forms/:id" component={FormShow} />
					<ProtectedRoute path="/templates/:id/edit" component={ShowTemplate} />
					<ProtectedRoute path="/templates/:id" component={ShowTemplate} />
					<ProtectedRoute path="/tenancies/:id/edit" component={EditTenancy} />
					<ProtectedRoute path="/tenancies/:id" component={ShowTenancies} />
					<ProtectedRoute path="/templates" component={ListTemplates} />
					<ProtectedRoute path="/settings" component={SettingsPage} />
					<ProtectedRoute path="/sla-monitor/configuration" component={SlaConfiguration} />
					<ProtectedRoute path="/sla-monitor/properties/:propertyId" component={SlaMonitorProperty} />
					<ProtectedRoute path="/sla-monitor" component={SlaMonitor} />
					<ProtectedRoute path="/executive-dashboard/:view?" component={ExecutiveDashboard} />
					<ProtectedRoute exact path="/" component={Home} />
					<ProtectedRoute component={Missing} />
				</Switch>
			</Suspense>
		</Router>
	</Fragment>
);
export default App;
